export default __webpack_public_path__ + "static/media/slots-rebate-ico.4d2fa98c.svg";